module.exports = __webpack_public_path__ + "static/media/view1.bf47d04e.jpg";